/* ============================================================
   kleinmed-custom.js
   Homepage + content-page section behaviour for Impact theme (BioRelax)
   Loaded via layout/theme.liquid <head> (deferred).
   ============================================================ */

(function () {
  'use strict';

  var ARROW_DOWN = '\u25BE'; // small down-pointing triangle
  var ARROW_UP = '\u25B4';   // small up-pointing triangle

  // i18n strings injected by layout/theme.liquid via `window.kleinmedI18n`.
  // DE fallbacks here so the file still works in isolation (e.g. theme editor).
  var I18N = (typeof window !== 'undefined' && window.kleinmedI18n) || {};
  var T = {
    refs_show: I18N.refs_show || 'Mehr Text anzeigen',
    refs_hide: I18N.refs_hide || 'Weniger Text anzeigen',
    faq_more:  I18N.faq_more  || 'weitere Fragen anzeigen',
    faq_less:  I18N.faq_less  || 'weniger Fragen anzeigen'
  };

  function initReferencesToggle() {
    // References section wrapper (both homepage and content-page variants)
    var sections = document.querySelectorAll('[id*="__references"]');
    sections.forEach(function (section) {
      if (section.querySelector('.kmrefs__toggle')) return;
      var ol = section.querySelector('ol');
      if (!ol) return;
      if (ol.children.length <= 3) return;
      if (section.dataset.refsInit === '1') return;
      section.dataset.refsInit = '1';

      section.classList.add('refs-collapsed');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'refs-toggle';
      btn.innerHTML = T.refs_show + ' ' + ARROW_DOWN;
      btn.setAttribute('aria-expanded', 'false');

      btn.addEventListener('click', function () {
        var collapsed = section.classList.toggle('refs-collapsed');
        btn.innerHTML = (collapsed ? T.refs_show + ' ' + ARROW_DOWN : T.refs_hide + ' ' + ARROW_UP);
        btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      });

      ol.parentNode.insertBefore(btn, ol.nextSibling);
    });
  }

  function initFaqShowMore() {
    // Applies to any Impact native FAQ section that opts in via
    // `.km-faq-show-more` on the section wrapper OR when the section has
    // more than 5 accordion items (wirkprinzip requirement: 5 visible, 4 hidden).
    var sections = document.querySelectorAll('[id*="__faq"]');
    sections.forEach(function (section) {
      if (section.dataset.faqMoreInit === '1') return;

      var items = section.querySelectorAll('details.accordion');
      if (!items || items.length <= 5) return;

      section.dataset.faqMoreInit = '1';
      section.classList.add('km-faq-collapsed');

      // Hide items 6+ via class (CSS hook)
      for (var i = 5; i < items.length; i++) {
        items[i].classList.add('km-faq-hidden');
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'km-faq-more';
      btn.innerHTML = T.faq_more + ' ' + ARROW_DOWN;
      btn.setAttribute('aria-expanded', 'false');

      btn.addEventListener('click', function () {
        var collapsed = section.classList.toggle('km-faq-collapsed');
        btn.innerHTML = (collapsed ? T.faq_more + ' ' + ARROW_DOWN : T.faq_less + ' ' + ARROW_UP);
        btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        // Reveal/hide items 6+
        for (var i = 5; i < items.length; i++) {
          if (collapsed) {
            items[i].classList.add('km-faq-hidden');
          } else {
            items[i].classList.remove('km-faq-hidden');
          }
        }
      });

      // Insert button after the accordion list container
      var stack = section.querySelector('.section-stack__main') || section.querySelector('.section-stack') || items[items.length - 1].parentNode;
      if (stack) {
        stack.appendChild(btn);
      }
    });
  }

  // Page-scoped: Beschwerden-und-Erkrankungen FAQ collapse-to-2.
  // Original kleinmed.net shows only 2 FAQ items on this page with a
  // turquoise pill reveal button. Our FAQ has 4 items - the generic
  // initFaqShowMore only triggers at >5, so we use a dedicated 2-item
  // collapse limited to this URL path.
  function initFaqShowMoreTwo() {
    if (location.pathname.indexOf('beschwerden-und-erkrankungen') === -1) return;
    var sections = document.querySelectorAll('[id*="__faq"]');
    sections.forEach(function (section) {
      if (section.dataset.faqMoreTwoInit === '1') return;

      var items = section.querySelectorAll('details.accordion');
      if (!items || items.length <= 2) return;

      section.dataset.faqMoreTwoInit = '1';
      section.classList.add('km-faq-collapsed-2');

      for (var i = 2; i < items.length; i++) {
        items[i].classList.add('km-faq-hidden-2');
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'km-faq-more';
      btn.innerHTML = T.faq_more + ' ' + ARROW_DOWN;
      btn.setAttribute('aria-expanded', 'false');

      btn.addEventListener('click', function () {
        var collapsed = section.classList.toggle('km-faq-collapsed-2');
        btn.innerHTML = (collapsed ? T.faq_more + ' ' + ARROW_DOWN : T.faq_less + ' ' + ARROW_UP);
        btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        for (var i = 2; i < items.length; i++) {
          if (collapsed) {
            items[i].classList.add('km-faq-hidden-2');
          } else {
            items[i].classList.remove('km-faq-hidden-2');
          }
        }
      });

      var stack = section.querySelector('.section-stack__main') || section.querySelector('.section-stack') || items[items.length - 1].parentNode;
      if (stack) {
        stack.appendChild(btn);
      }
    });
  }

  function initAll() {
    initReferencesToggle();
    initFaqShowMore();
    initFaqShowMoreTwo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (evt) {
    if (!evt || !evt.target || !evt.target.id) return;
    var id = evt.target.id;
    if (id.indexOf('__references') !== -1) {
      delete evt.target.dataset.refsInit;
      initReferencesToggle();
    }
    if (id.indexOf('__faq') !== -1) {
      delete evt.target.dataset.faqMoreInit;
      delete evt.target.dataset.faqMoreTwoInit;
      initFaqShowMore();
      initFaqShowMoreTwo();
    }
  });
})();
